module.exports = __webpack_public_path__ + "static/media/kyra_wells.71f13d9c.png";